<template>
  <p style="width:100%;text-align:left;margin-bottom:0;  overflow: auto;white-space: nowrap;">
    <el-tag :key="thesaved.tag" v-for="thesaved in thesavedsearch" :closable="thesaved.source == undefined"
      :disable-transitions="false" @close="handleClose(thesaved.tag)" @click="tagclick(thesaved)">
      {{ thesaved.tag }}
    </el-tag>
  </p>
</template>


<script>

export default {
  data() {
    return {};
  },

  computed: {
    history() {
      return this.$store.state.history
    },
    thesavedsearch() {
      //history的tag
      let historytag = [
        { tag: "⮪", history: "back", source: true },
        { tag: "⮫", history: "forward", source: true },
      ]

      let addon = [{ tag: "Pure", value: "addonhidden", source: true }]
      //本地的tag
      let localsavedsearch = this.$store.state.savedsearch.filter((obj) => {
        return (
          obj.collection === this.$store.state.collection.value ||
          obj.tag.includes("*")
        );
      });
      //remote的tag
      let isavesearch = this.$store.state.collection.isavesearch || [];
      //用于标记是否closable
      isavesearch.forEach(obj => {
        obj.source = "remote"
      })

      //如果isavesearch第一个为标记为#的tag，默认为初始值，进行设置
      // if (isavesearch.length > 0 && isavesearch[0].tag.includes("#") && isavesearch[0].toeval) {
      //   eval(isavesearch[0].toeval)
      // }

      let thesavedsearch = historytag.concat(addon, isavesearch, localsavedsearch);
      return thesavedsearch;
    },
  },
  methods: {
    tagclick(thesaved) {
      if (thesaved.value = "addonhidden") {
        let shows = []
        this.$store.state.currentheader.forEach(fieldobj => {
          if (fieldobj.type != "addon") {
            shows.push(fieldobj.name)
          }
        })

        if (shows.length > 0) {
          let record = { tag: "Pure", fieldsset: { shows: shows } }
          this.$store.commit("setunshowfields", record)
        }


      }
      //如果点击的是history
      if (thesaved.history) {
        if (thesaved.history == "back") {
          this.$axios.searchfromurl(this.history[1])
            .then(() => {

              this.historyresort()

            })

        }

        if (thesaved.history == "forward") {
          this.$axios.searchfromurl(this.history.at(-1))
            .then(() => {

            })

        }

      }

      //如果点击的为含href的tag
      if (thesaved.href) {
        this.$axios.searchfromurl(thesaved.href)
      }

      //如果点击的是toeval的tag，toeval只可能来自服务器collection的设置
      if (thesaved.toeval) {
        eval(thesaved.toeval)
      }

    },
    historyresort(model) {
      //重新history的herf移动到最后
      let currentindex = 1
      let history = JSON.parse(JSON.stringify(this.history))
      let currenthref = history.at(currentindex)

      history.splice(currentindex, 1)
      history[history.length] = currenthref

      this.$store.commit("sethistory", history)
    },

    handleClose(tag) {
      this.$confirm(
        "Delete tag?",
        "Warning",
        {
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          type: "warning",
        }
      ).then(() => { this.$store.commit("removesavedsearch", tag); });

    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/savesearch_list.vue